import { formatISO } from 'date-fns';
import { useTranslation } from 'next-i18next';

import { HomeWidgetEmptyState } from '@/modules/home';
import { useGetLatestPeriodicOperations } from '@/modules/home/apiHooks';
import { useHomeInputsUtils } from '@/modules/home/components/PageContent/Inputs/logic';
import { useHomePageContext } from '@/modules/home/context';
import { IHome } from '@/modules/home/types';
import { Table } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Tractor from '~/images/shared/Tractor.svg';

const PeriodicOperationsTable = () => {
  const { t } = useTranslation();

  const [selectedAsset] = useStore((store) => store?.asset);

  const {
    state: { date },
  } = useHomePageContext();

  const {
    data: response,
    hasNextPage,
    fetchNextPage,
  } = useGetLatestPeriodicOperations({
    entityId: selectedAsset?.id,
    date: formatISO(date, { representation: 'date' }),
    page: 1,
    limit: 10,
  });

  const { getPeriodicOperationsColumns } = useHomeInputsUtils();

  const data = response?.pages?.flatMap((page) => page.items);

  return data?.length ? (
    <Table<IHome.IPeriodicOperation>
      data={data}
      columns={getPeriodicOperationsColumns()}
      selection={false}
      pagination={false}
      headCellClassName='text-start [&>div]:text-14 border-b-xs border-neutralVariant-90 text-surface-10'
      headContainerClassName='!bg-background-neutral-99'
      rowContainerClassName='!bg-background-transparent last-of-type:border-b-0 border-neutralVariant-90 border-b-xs'
      tableWrapperClassName='max-h-343'
      tableClassName='!border-collapse'
      headerClassName='!z-[1]'
      infiniteScrollProps={{
        hasMore: hasNextPage,
        loadMore: () => fetchNextPage(),
      }}
    />
  ) : !data?.length ? (
    <HomeWidgetEmptyState
      icon={
        <span className='text-primary-60'>
          <Tractor width='48' height='48' />
        </span>
      }
      title={t('no-operations')}
      message={t('create-operations-from-app')}
    />
  ) : null;
};

export { PeriodicOperationsTable };
